import { Component, OnInit, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4'
import { AttendanceService } from '../attendance.service';
import { FilterdialogComponent } from '../filterdialog/filterdialog.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../course-Master/course-fee/http.service';

import { NgDialogAnimationService } from 'ng-dialog-animation';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BasemodelService } from 'src/app/basemodel.service';

@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss']
})
export class AttendanceComponent implements OnInit {
  ATTENDANCE!: FormGroup;
  studentData: any;
  attendanceData: any;
  // weekDetailsOrder = ["STRENGTH", "PRESENT", "WORKING DAYS", "ATTENDANCE(%)"];
  selectedColumn: any;
  tableData: any;

  width: number;
  height: number;
  top: string;
  right: string;
  // dataTable: JQuery<Document>;
  show: any = 0;
  show1: boolean = false;

  classId: any;
  streamId: any;
  programId: any;
  examProgramId: any;
  sectionId: any;
  buildingId: any;
  count = 0;

  startdate: any;
  enddate: any;
  allWeeks: any[] = [];
  weekHeaders: string[] = [];
  data: any;
  main: any;
  addFilter: any;
  addFilterDisplay: string = 'none';
  filterContainerdisplay: string = 'none'
  camelCaseString: string;
  values = 'Today'
  dialogConfig: any;
  selectedOption: 'Today'
  filterCount: any;
  value: any;

  // attendanceData: any;
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  excelList: any[] = [];
  filterValue: string;
  isDataAvailable: boolean = true;
  searchInputtext: string;
  servicelist: any;

  campusId: any;
  private campus = "&campusId="
  private building = "&buildingId="
  private class = "&classId="
  private stream = "&streamId="
  private section = "&sectionId="
  private program = "&programId="
  private filterBy = "&filterBy=";
  private examProgramID = "&examProgramId="

  constructor(private attendanecs: AttendanceService, private http: HttpService, private fb: FormBuilder, private dialog: NgDialogAnimationService, private spinner: NgxSpinnerService,) {

  }

  toCamelCase(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }


  ngOnInit(): void {
    // this.base()
    // this.weekFilterList()
    this.getattendenceslist()

  }
  getweek() {
    this.spinner.show()
    this.attendanecs.getweekAttendances('lastweek').subscribe(
      (data: any[]) => this.getweeklist(data)
    );
    // this.spinner.hide()
  }
  getweeklist(data: any) {
    if (data && data.length > 0) {
      const transformedData = data.map((item: any) => {
        const weekDetails = item.WEEKS.reduce((acc: any, week: any) => {
          if (!week.WEEK_NUMBER || !week.WEEK_DETAILS) {
            console.warn(`Missing week details for week: ${week.WEEK_NUMBER}`);
            return acc;
          }
          const weekNumber = week.WEEK_NUMBER;
          const weekDateRange = week.WEEK_START_END_DATE || '';
          const formattedDateRange = `(${weekDateRange.replace('-', '-')})`;

          // Create the keys with the two-line format
          acc[`W${weekNumber}_STR ${formattedDateRange}`] = week.WEEK_DETAILS?.STRENGTH || 0;
          acc[`W${weekNumber}_PRST ${formattedDateRange}`] = week.WEEK_DETAILS?.PRESENT || 0;
          acc[`W${weekNumber}_WRKDAY ${formattedDateRange}`] = week.WEEK_DETAILS?.['WORKING DAYS'] || 0;
          acc[`W${weekNumber}_ATTNCE ${formattedDateRange}`] = week.WEEK_DETAILS?.['ATTENDANCE(%)'] || 0;

          return acc;
        }, {});

        return {
          "State Name": item.STATE_NAME || 'N/A',
          "City Name": item.CITY_NAME || 'N/A',
          "Campus Name": item.CAMPUS_NAME || 'N/A',
          "Class Name": item.CLASS_NAME || 'N/A',
          Section: item.SECTION_NAME || 'N/A',
          Program: item.PROGRAM_NAME || 'N/A',
          "Exam Program": item.EXAM_PROGRAM_NAME || 'N/A',
          ...weekDetails
        };
      });
      const dynamicHeaders = new Set<string>();

      transformedData.forEach((item: any) => {
        Object.keys(item).forEach(key => {
          if (key.startsWith('W')) {
            dynamicHeaders.add(key);
          }
        });
      });
      this.dataSource.data = transformedData;
      this.displayedColumns = [
        'State Name',
        'City Name',
        'Campus Name',
        'Class Name',
        'Section',
        'Program',
        'Exam Program',
        ...Array.from(dynamicHeaders)
      ]
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      this.searchInputtext = "";
      this.filterValue = "";
      this.dataSource.filter = "";
      this.isDataAvailable = true;
    } else {
      this.isDataAvailable = false;
    }

    this.spinner.hide()
  }
  applyFilter(e: any) {
    this.filterValue = (e.target as HTMLInputElement).value;
    this.dataSource.filter = this.filterValue.trim().toLowerCase();
    console.log('filterValue', this.filterValue);
  }
  exporttoexcel() {
    const dataToExport = this.dataSource.data;
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Week Data': worksheet },
      SheetNames: ['Week Data']
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `WeekData.xlsx`);
    alert("Excel will download please check the your download list")
  }
  clear() {
    this.addFilterDisplay = 'none';
  }
  openDialog() {
    this.addFilterDisplay = 'flex';
  }
  filterdialog() {
    const data1 = {
      "values": this.value,
      "stardate1": this.startdate,
      "enddate1": this.enddate
    }

    const dialogRef = this.dialog.open(FilterdialogComponent, {
      width: "410px",
      height: "1000px",
      panelClass: ['animate__animated', 'animate__slideInRight'],
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      disableClose: true,
      hasBackdrop: false,
      data: data1
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      this.filterCount = result.filterCount;
      this.campusId = result.campusId
      this.buildingId = result.buildingId;
      this.classId = result.classId;
      this.streamId = result.streamId;
      this.sectionId = result.sectionId;
      this.programId = result.programId;
      this.examProgramId = result.examProgramId;
      this.startdate = result.startDate;
      this.enddate = result.endDate;
      this.value = result.data
      if (this.value == 'Today') {
        this.gettodayandyesterdaylist()
      }
      else if (this.value == "Yesterday") {
        // this.filterlistmethod()
        this.gettodayandyesterdaylist()
      }
      else if (this.value == "lastweek") {
        // this.weekFilterList() 
        this.getattendenceslist()

      }
      else if (this.value == "lastmonth") {
        // this.weekFilterList()
        this.getattendenceslist()
      }
      else if (this.value == "last3months") {
        // this.weekFilterList()
        this.getattendenceslist()
      }
      else if (this.value == "last6months") {
        // this.weekFilterList()
        this.getattendenceslist()
      }
      else if (this.value == "betweendates") {
        if (this.startdate == this.enddate) {
          this.getselecteddatelist()
        } else {
          this.getbetweendateslist()
        }

      }
      this.count = result.count
    });

  }
  isNumericColumn(column: string): boolean {
    return column.startsWith('W') || ['PRESENT', 'STRENGTH', 'WORKING DAYS', 'ATTENDANCE(%)'].some(numCol => column.includes(numCol));
  }
  closefilter() {
    this.filterContainerdisplay = 'none'
  }
  search() {
    this.closefilter()
  }
  searchfilter() {
    this.addFilterDisplay = 'none';
  }

  // filterlistmethod() {
  //   if (this.filterCount == 4) {
  //     this.getFilterList(this.buildingId, '', '', '', '', '')
  //   }
  //   else if (this.filterCount == 5) {
  //     this.getFilterList(this.buildingId, this.classId, '', '', '', '')
  //   }
  //   else if (this.filterCount == 6) {
  //     this.getFilterList(this.buildingId, this.classId, this.streamId, '', '', '')
  //   }
  //   else if (this.filterCount == 7) {
  //     this.getFilterList(this.buildingId, this.classId, this.streamId, this.sectionId, '', '')
  //   }
  //   else if (this.filterCount == 8) {
  //     this.getFilterList(this.buildingId, this.classId, this.streamId, this.sectionId, this.programId, '')
  //   }
  //   else if (this.filterCount == 9) {
  //     this.getFilterList(this.buildingId, this.classId, this.streamId, this.sectionId, this.programId, this.examProgramId)
  //   }
  //   else {
  //     this.spinner.show()

  //   }
  // }
  // weekFilterList() {
  //   if (this.filterCount == 4) {
  //     this.getWeekFilterList(this.buildingId, '', '', '', '', '')
  //   }
  //   else if (this.filterCount == 5) {
  //     this.getWeekFilterList(this.buildingId, this.classId, '', '', '', '')
  //   }
  //   else if (this.filterCount == 6) {
  //     this.getWeekFilterList(this.buildingId, this.classId, this.streamId, '', '', '')
  //   }
  //   else if (this.filterCount == 7) {
  //     this.getWeekFilterList(this.buildingId, this.classId, this.streamId, this.sectionId, '', '')
  //   }
  //   else if (this.filterCount == 8) {
  //     this.getWeekFilterList(this.buildingId, this.classId, this.streamId, this.sectionId, this.programId, '')
  //   }
  //   else if (this.filterCount == 9) {
  //     this.getWeekFilterList(this.buildingId, this.classId, this.streamId, this.sectionId, this.programId, this.examProgramId)
  //   }
  //   else {
  //     this.getweek()
  //   }
  // }
  // betweendatesList() {
  //   if (this.filterCount == 4) {
  //     this.getbetweendatesList(this.buildingId, '', '', '', '', '')
  //   }
  //   else if (this.filterCount == 5) {
  //     this.getbetweendatesList(this.buildingId, this.classId, '', '', '', '')
  //   }
  //   else if (this.filterCount == 6) {
  //     this.getbetweendatesList(this.buildingId, this.classId, this.streamId, '', '', '')
  //   }
  //   else if (this.filterCount == 7) {
  //     this.getbetweendatesList(this.buildingId, this.classId, this.streamId, this.sectionId, '', '')
  //   }
  //   else if (this.filterCount == 8) {
  //     this.getbetweendatesList(this.buildingId, this.classId, this.streamId, this.sectionId, this.programId, '')
  //   }
  //   else if (this.filterCount == 9) {
  //     this.getbetweendatesList(this.buildingId, this.classId, this.streamId, this.sectionId, this.programId, this.examProgramId)
  //   }
  //   else {
  //     this.attendanecs.getAttendence(this.value)
  //   }
  // }
  // getFilterList(buildingId: any, classid: any, streamid: any, sectionId: any, programid: any, examProgramId: any) {
  //   this.spinner.show()
  //   this.attendanecs.getFilterList(this.value, buildingId, classid, streamid, sectionId, programid, examProgramId).subscribe((res: any) => {
  //     this.attendanceData = res;
  //     this.isDataAvailable = this.attendanceData && this.attendanceData.length > 0;
  //     if (this.isDataAvailable) {
  //       this.displayedColumns = this.getCommonKeys(this.attendanceData).filter(column => !column.toLowerCase().endsWith('id'));
  //       this.dataSource = new MatTableDataSource(this.attendanceData);
  //       this.dataSource.paginator = this.paginator;
  //       this.dataSource.sort = this.sort;
  //       this.searchInputtext = "";
  //     }
  //     this.spinner.hide()

  //   })

  // }
  // getWeekFilterList(buildingId: any, classid: any, streamid: any, sectionId: any, programid: any, examProgramId: any) {
  //   this.spinner.show()
  //   this.attendanecs.getWeekFilterList(this.value, buildingId, classid, streamid, sectionId, programid, examProgramId).subscribe(
  //     (data: any[]) => this.getweeklist(data)

  //   );
  //   this.filterValue=""
  // }
  // getbetweendatesList(buildingId: any, classid: any, streamid: any, sectionId: any, programid: any, examProgramId: any) {
  //   this.spinner.show()
  //   this.attendanecs.getbetweendatesList(this.startdate, this.enddate, buildingId, classid, streamid, sectionId, programid, examProgramId).subscribe(
  //     (data: any[]) => this.getweeklist(data)
  //   );
  //   this.filterValue=""
  // }
  getCommonKeys(dataArray: any[]): string[] {
    if (!dataArray || dataArray.length === 0) {
      return [];
    }
    let commonKeys = Object.keys(dataArray[0]);
    dataArray.forEach(obj => {
      commonKeys = commonKeys.filter(key => obj.hasOwnProperty(key));
    });
    return commonKeys;
  }
  dymaicurlattednces() {
    let url = ""

    if (this.value == "betweendates") {
      if (this.startdate == this.enddate) {
        url = `selectedDate=${this.startdate}`
      } else {
        url = `startDate=${this.startdate}&endDate=${this.enddate}`;
      }
    } else {

      url = this.value ? `filterBy=${this.value}` : "filterBy=lastweek";
    }
    if (this.campusId) {
      url = url + this.campus + this.campusId
    }
    if (this.buildingId) {
      url = url + this.building + this.buildingId
    }
    if (this.classId) {
      url = url + this.class + this.classId
    }
    if (this.streamId) {
      url = url + this.stream + this.streamId
    }
    if (this.programId) {

      url = url + this.program + this.programId
    }
    if (this.sectionId) {
      url = url + this.section + this.sectionId
    }
    url = url

    return url;
  }
  getattendenceslist() {
    this.spinner.show()
    const url = this.dymaicurlattednces();
    this.attendanecs.getattendancesdymaic(url).subscribe(
      (data: any[]) => this.getweeklist(data)
    );
  }
  gettodayandyesterdaylist() {
    this.spinner.show();
    const url = this.dymaicurlattednces();
    this.attendanecs.getattendancestodayandyesterday(url).subscribe({
      next: (res) => {
        this.attendanceData = res;
        this.isDataAvailable = this.attendanceData && this.attendanceData.length > 0;

        if (this.isDataAvailable) {
          this.displayedColumns = this.getCommonKeys(this.attendanceData).filter(column => !column.toLowerCase().endsWith('id'));

          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(this.attendanceData);
          } else {
            this.dataSource.data = this.attendanceData;
          }
          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          });
          this.searchInputtext = "";
        }
        this.spinner.hide();
      },
      error: (err) => {
        console.error("Error fetching attendance data:", err);
        this.isDataAvailable = false;
        this.spinner.hide();
      },
    });
  }
  getbetweendateslist() {
    this.spinner.show()
    const url = this.dymaicurlattednces();
    this.attendanecs.getbetweendates(url).subscribe(
      (data: any[]) => this.getweeklist(data)
    );
  }
  getselecteddatelist() {
    this.spinner.show()
    const url = this.dymaicurlattednces();
    this.attendanecs.getselecteddate(url).subscribe({
      next: (res) => {
        this.attendanceData = res;
        this.isDataAvailable = this.attendanceData && this.attendanceData.length > 0;

        if (this.isDataAvailable) {
          this.displayedColumns = this.getCommonKeys(this.attendanceData).filter(column => !column.toLowerCase().endsWith('id'));
          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(this.attendanceData);
          } else {
            this.dataSource.data = this.attendanceData;
          }
          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          });

          this.searchInputtext = "";
        }
        this.spinner.hide();
      },
      error: (err) => {
        console.error("Error fetching attendance data:", err);
        this.isDataAvailable = false;
        this.spinner.hide();
      },
    });
  }

  getColumnLabel(column: string): string {
    return column.split(' (')[0].trim();
  }
  getColumnDateRange(column: string): string {
    const match = column.match(/\(([^)]+)\)/);
    return match ? match[1] : '';
  }
}
